"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNode = exports.isReactNative = void 0;
exports.extensionFromMime = extensionFromMime;
exports.mediaInfoFrom = mediaInfoFrom;
exports.polyfillMime = polyfillMime;
exports.checkMimeValidation = checkMimeValidation;
exports.isMimeValidForType = isMimeValidForType;
exports.isAudioSupportedBySafari = isAudioSupportedBySafari;
exports.getSafariSupportedAudioMimes = getSafariSupportedAudioMimes;
exports.setFileExtension = setFileExtension;
const constants_1 = require("../constants");
const mime_types_json_1 = __importDefault(require("./mime-types.json"));
const EXT_TO_MIME = {};
const MIME_TO_EXT = {};
for (const [mimeType, data] of Object.entries(mime_types_json_1.default)) {
    if (data.extensions && Array.isArray(data.extensions) && data.extensions.length > 0) {
        MIME_TO_EXT[mimeType] = data.extensions[0];
        for (const ext of data.extensions) {
            if (!EXT_TO_MIME[ext]) {
                EXT_TO_MIME[ext] = mimeType;
            }
        }
    }
}
function extensionFromMime(mime) {
    if (!mime)
        return 'unknown';
    const cleanMime = mime.toLowerCase().trim().split(';')[0];
    return MIME_TO_EXT[cleanMime] || 'unknown';
}
exports.isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
exports.isNode = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
async function mediaInfoFrom(input) {
    if (!input)
        throw new Error('Input is required');
    let ext = 'unknown';
    let mime = null;
    let name = '';
    if (typeof input === 'string') {
        input = input.trim();
        if (/^https?:\/\//i.test(input)) {
            throw new Error('Network fetching is disabled. HTTP/HTTPS addresses are not allowed here.');
        }
        input = input.split(/[?#]/)[0];
        if (!exports.isReactNative && input.startsWith('blob:')) {
            try {
                const blob = await fetch(input).then((res) => res.blob());
                name = input.split(/[/\\]/).pop() || `blob_${Date.now()}`;
                const { fileTypeFromBlob } = await Promise.resolve().then(() => __importStar(require('file-type')));
                const res = await fileTypeFromBlob(blob);
                if (res) {
                    mime = polyfillMime(blob, res.mime);
                    ext = res.ext;
                }
            }
            catch { }
        }
        else if (exports.isNode && !input.startsWith('blob:')) {
            try {
                const { fileTypeFromFile } = await Promise.resolve().then(() => __importStar(require('file-type')));
                const res = await fileTypeFromFile(input);
                if (res) {
                    mime = res.mime;
                    ext = res.ext;
                }
            }
            catch { }
        }
        name ??= input.split(/[/\\]/).pop() || '';
        const result = parseFromStringPath(input);
        if (ext === 'unknown' || ext === undefined)
            ext = result.ext;
        if (mime === null || mime === undefined)
            mime = result.mime;
    }
    else {
        if ('name' in input && typeof input.name === 'string' && input.name) {
            name = input.name;
        }
        if (input.type) {
            mime = input.type;
            ext = MIME_TO_EXT[mime] || 'unknown';
        }
        if (!exports.isReactNative) {
            try {
                const { fileTypeFromBlob } = await Promise.resolve().then(() => __importStar(require('file-type')));
                const detected = await fileTypeFromBlob(input);
                if (detected) {
                    ext = detected.ext;
                    mime = polyfillMime(input, detected.mime);
                }
            }
            catch { }
        }
    }
    if (!name) {
        name = `file_${Date.now()}`;
    }
    name = setFileExtension(name, String(ext));
    return { mime: mime || 'application/octet-stream', name };
}
function polyfillMime(blob, detectedMime) {
    if (!detectedMime) {
        return detectedMime;
    }
    if (blob.type === 'audio/m4a' && (detectedMime === 'video/mp4' || detectedMime === 'audio/mp4')) {
        return blob.type;
    }
    if (blob.type === 'audio/webm' && detectedMime === 'video/webm') {
        return blob.type;
    }
    return detectedMime;
}
function checkMimeValidation(mime, type) {
    if (!isMimeValidForType(mime, type)) {
        throw new Error(`${mime} is not a valid ${type.toLowerCase()}`);
    }
}
function isMimeValidForType(mime, type) {
    if (!mime)
        return false;
    const lowerMime = mime.toLowerCase().trim();
    switch (type) {
        case constants_1.FileTypeEnum.IMAGE:
            return lowerMime.startsWith('image/') && lowerMime !== 'image/gif';
        case constants_1.FileTypeEnum.GIF:
            return lowerMime === 'image/gif';
        case constants_1.FileTypeEnum.PDF:
            return lowerMime === 'application/pdf';
        case constants_1.FileTypeEnum.AUDIO:
            return lowerMime.startsWith('audio/');
        case constants_1.FileTypeEnum.VIDEO:
            return lowerMime.startsWith('video/');
        case constants_1.FileTypeEnum.UNKNOWN:
            return true;
        default:
            return false;
    }
}
function parseFromStringPath(str) {
    str = str.split(/[?#]/)[0];
    const filename = str.split(/[/\\]/).pop() || '';
    const dotIndex = filename.lastIndexOf('.');
    let ext = 'unknown';
    let mime = 'application/octet-stream';
    if (dotIndex > 0) {
        ext = filename.substring(dotIndex + 1).toLowerCase();
        mime = EXT_TO_MIME[ext] || 'application/octet-stream';
    }
    return { ext, mime };
}
function isAudioSupportedBySafari(mime) {
    if (!mime)
        return false;
    const cleanMime = mime.toLowerCase().trim();
    return getSafariSupportedAudioMimes().some((supportedMime) => cleanMime === supportedMime || cleanMime.startsWith(`${supportedMime};`));
}
function getSafariSupportedAudioMimes() {
    return [
        'audio/mpeg',
        'audio/mp4',
        'audio/aac',
        'audio/wav',
        'audio/x-wav',
        'audio/flac',
    ];
}
function setFileExtension(fileName, extension) {
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex > 0) {
        fileName = fileName.substring(0, lastDotIndex) + `.${extension}`;
    }
    else {
        fileName += `.${extension}`;
    }
    return fileName;
}
